<template>
  <div id="app">
    <div id="box">
      <!-- <ComHeader v-if="name !== 'home'"></ComHeader> -->
      <router-view v-if="isRouterAlives_" />
      <!-- <ComFooter class="footer_css"></ComFooter> -->
      <!--  v-bind:style="{ minHeight: Height + 'px' }" -->
    </div>
  </div>
</template>
<script>
import ComHeader from "@/components/ComHeader.vue";
import ComFooter from "@/components/ComFooter.vue";
export default {
  name: "App",
  provide() {
    return {
      reloads_: this.reloads_,
    };
  },
  onLaunch: function (option) {
    // console.log(option.path);
  },

  data() {
    return {
      Height: 0,
      name: "",
      isRouterAlives_: true,
    };
  },
  created() {
    //  console.log(this.$route.path)
    this.name = this.$route.name;
    // console.log('a')
  },
  watch: {
    $route(to, from) {
      this.name = to.name;
      // console.log(to.name)
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是190
    // console.log(this.name)
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
    // console.log(this.$route.path);
    // console.log(this.Height);
  },

  methods: {
    reloads_() {
      this.isRouterAlives_ = false;
      this.$nextTick(function () {
        this.isRouterAlives_ = true;
      });
    },
  },
  components: {
    ComHeader, ComFooter,
  },
  watch: {
    $route(to, from) {
      // console.log(to, from);
    },
  },
};
</script>

<style lang="less">
#app {
  display: flex;
  justify-content: center;
  // padding: 20px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
}

#box {
  width: 100%;
  max-width: 800px;
}
.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
<style >
/* body::-webkit-scrollbar {
  display: none;
}
#app::-webkit-scrollbar {
  display: none;
}
#box::-webkit-scrollbar {
  display: none;
} */
html, body {
  overflow-x: hidden; /* 禁止水平滚动 */
  overflow-y: auto; /* 启用垂直滚动 */
  -webkit-overflow-scrolling: touch; /* 使用原生滚动 */
}
</style>
